import { VitalSignService } from '../../core/http/service/VitalSignService';
import BaseResponse from '../../models/core/BaseResponse';
import VitalSign from '../../models/core/careLine/VitalSign';
 
export const FETCH_VITAL_SIGNS = 'FETCH_VITAL_SIGNS';

const sendToAnalytics = (action: string = '', error: any = null) =>{
    console.error(action, error); 
}
 
export const fetchVitalSigns = ()=>{
    const service: VitalSignService = new VitalSignService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getAll()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
            const vitalSigns: VitalSign[] = []
            baseResponse.data.forEach((data: any)=>{
                vitalSigns.push(new VitalSign().fromJSON(data))
            })

            dispatch({ 
                type: FETCH_VITAL_SIGNS, 
                vitalSigns: vitalSigns
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const filterVitalSignByName = (searchQuery: string)=>{
    const service: VitalSignService = new VitalSignService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getByResource('', { PageSize: 500, Nome: searchQuery })
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
            const vitalSignsFiltered: VitalSign[] = []
            baseResponse.data.forEach((data: any)=>{
                vitalSignsFiltered.push(new VitalSign().fromJSON(data))
            })

            dispatch({ 
                type: FETCH_VITAL_SIGNS, 
                vitalSigns: vitalSignsFiltered
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const fetchVitalSignById = (id: string) => {
    return async (dispatch: any) => {
        try {
            const service = new VitalSignService();
            const resp = await service.getById(id);
            return resp.data;
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const registerVitalSign = (vitalSign: VitalSign) => {
    const service: VitalSignService = new VitalSignService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.post(vitalSign)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const updateVitalSign = (vitalSign: VitalSign, vitalSignId: string)=>{
    const service: VitalSignService = new VitalSignService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.putByResource(vitalSign, vitalSignId)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const activateOrDeactivateVitalSign = (isActivate: boolean, vitalSignId: string)=>{
    const service: VitalSignService = new VitalSignService()
    return async (dispatch: any) => {
        try {
            if (isActivate) {
               await service.patchByResource({} as VitalSign, `${vitalSignId}/Activate`)
            } else {
               await service.patchByResource({} as VitalSign, `${vitalSignId}/Inactivate`)
            }
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}
